import React, { useContext } from 'react'
import styled from 'styled-components'
import { Button, StyledButton } from '@monbanquet/crumble'
import { colors, breakpoints } from '../theme'
import { navigate } from './Link'
import { EventContext } from './context/EventContext'
import Arrow from '../assets/arrow.svg'
import { computeNextPage, withBaseUri } from '../util/compute-next-page'
import Slider from 'react-slick'
import mailIcon from '../assets/envelope-regular.svg'

function isMonbanquetClosed() {
  const now = Date.now()
  const startClosingDate = new Date('2019-12-24T17:00:00')
  const endClosingDate = new Date('2020-01-02T12:00:00')
  return now > startClosingDate && now < endClosingDate
}

function isMonbanquetClosedCoronaVirus() {
  return true
}

const EventFormatSelector = () => {
  const { categories, dispatch } = useContext(EventContext)

  const selectEventFormat = slug => {
    dispatch({
      type: 'UPDATE_CATEGORY',
      payload: { category: slug, multiMoment: false },
      analytics: { label: 'From_EventFormatSelector' },
    })

    const addBaseUri = withBaseUri('demande')
    navigate(addBaseUri(computeNextPage('root')), { state: { next: true } })
  }

  const selectMultiMoment = () => {
    dispatch({
      type: 'UPDATE_IS_MULTI_MOMENT',
      payload: { category: null, multiMoment: true },
      analytics: { label: 'From_EventFormatSelector' },
    })

    const addBaseUri = withBaseUri('demande')
    navigate(
      addBaseUri(computeNextPage('root', null, { isMultiMoments: true })),
      {
        state: { next: true },
      },
    )
  }

  const mailTo = () => {
    const subject = encodeURIComponent('Demande spécifique / Site')
    const body = encodeURIComponent('')
    const mailtoLink = `mailto:sales@monbanquet.fr?subject=${subject}&body=${body}`
    window.location.href = mailtoLink
  }

  const goToDevis = () => {
    const addBaseUri = withBaseUri('demande')
    navigate(addBaseUri('/'), { state: { next: true } })
  }

  return (
    <StyledEventFormatSelector>
      <div className="formats formats-grid">
        {categories.map(cat => (
          <Button
            key={cat.slug}
            className="format"
            onClick={() => selectEventFormat(cat.slug)}
          >
            <div className="name">{cat.title}</div>
            <div className="suggested-hours">{cat.suggestedHours}</div>
            <div className="arrow">
              <img src={Arrow} alt="arrow" />
            </div>
          </Button>
        ))}
      </div>
      <div className="formats-bottom">
        <Button className="format multi-moment" onClick={mailTo}>
          <div className="name">
            <img className="mail-icon" src={mailIcon} alt="mail" />
            <span className="mail-to-text">
              {' '}
              {`Pour vos évènements plus spécifiques, écrivez nous ici ! `}
            </span>
            {/*  <span className="underline">{`plusieurs créneaux`}</span> */}
          </div>
        </Button>
        {/*<p className="hint-text">
          
          isMonbanquetClosed()
          ? `Recevez un devis à partir du 2 Janvier 2020`
          : `Recevez un devis en moins de 3 heures`
          </p>*/}
        <p className="locations">{`Paris | Lyon`}</p>
      </div>
    </StyledEventFormatSelector>
  )
}

const StyledEventFormatSelector = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  padding: 0 30px;

  .mail-icon {
    max-width: 25px;
    margin-right: 10px;
    position: relative;
    top: -5px;
  }

  .mail-to-text {
    position: relative;
    top: -12px;
  }

  .hint-text {
    color: ${colors.brand.green};
    font-size: 14px;
    text-align: center;
    font-weight: bold;
  }

  .container {
    padding: 8px 0;
  }

  .formats {
    ${StyledButton} {
      text-transform: none;
      letter-spacing: unset;
      text-align: left;
      height: 82px;
    }

    ${StyledButton}.format {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      padding: 2px 16px;
      border-radius: 30px;
      border: 2px solid ${colors.text.dark}!important;
      background-color: ${colors.brand.beige};

      .name {
        color: ${colors.text.dark};
        font-weight: 700;
        font-size: 19px;
        text-align: center;
      }

      .suggested-hours {
        color: ${colors.text.dark};
        font-size: 19px;
        opacity: 0.7;
        text-align: right;
      }

      .arrow {
        position: absolute;
        right: 16px;
        text-align: right;
        font-size: 20px;
        align-items: center;
        justify-content: flex-end;
        display: none;

        img {
          transform: rotate(180deg);
          max-width: 25px;
        }
      }

      &:hover {
        box-shadow: none;
        background-color: ${colors.brand.beige};

        .arrow {
          display: inline;
        }
      }
    }
  }

  .formats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 1fr;
    height: 50vh;
    gap: 16px;
    place-items: center;
    overflow: hidden;
  }

  .formats-bottom {
    margin-top: 24px;

    ${StyledButton}.format.multi-moment {
      width: 100%;
      text-align: center;
      background-color: ${colors.brand.normal};
      .name {
        color: ${colors.brand.inverted};
        font-weight: normal;
        flex-grow: 1;
      }
    }
  }

  .locations {
    color: #383838;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  @media (max-height: 810px) and (min-width: ${breakpoints.desktop}px) {
    .hint-text {
      font-size: 15px;
      margin-bottom: 10px;
    }
    .formats {
      ${StyledButton}.format {
        padding: 16px 25px;

        .name {
          font-size: 16px;
        }
      }
    }
  }

  @media (max-width: ${breakpoints.desktop}px) {
    .hint-text {
      margin-bottom: 14px;
      color: ${colors.brand.green};
      font-size: 17px;
      text-align: center;
      font-weight: bold;
    }

    .formats {
      ${StyledButton} {
        height: 48px;
        &.format {
          padding: 10px 25px;

          .name {
            font-size: 17px;
          }

          .suggested-hours {
            font-size: 17px;
            display: none;
          }

          .arrow {
            flex-grow: 1;
            text-align: right;
            font-size: 17px;
          }
        }
      }
    }
    .locations {
      margin-top: 5px;
      font-size: 12px;
    }
  }

  @media (max-width: ${breakpoints.desktop}px) {
    padding: 20px 5px 30px;

    .hint-text {
      display: none;
    }

    .formats {
      ${StyledButton} {
        &.format {
          .name {
            flex-basis: 80%;
            font-size: 15px;
          }

          &:last-child {
            .name {
              font-size: 12px;
            }
          }
        }
      }
    }
    .locations {
      margin-top: 10px;
      font-size: 9px;
      text-transform: uppercase;
      margin-bottom: 50px;
    }
  }
`

export default EventFormatSelector
export { StyledEventFormatSelector }
